import { FC, useEffect, useState } from 'react'
import { BundleItem } from './BundleItem'
import { BundleList, TopUpBalanceModalTitle, TopUpBalanceTilte, TopUpBalanceWrapper, TopUpBalanceWrapperOuter, TopUpHint } from './styles'
import { API } from '@brg/api'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '@brg/ui'
import { useModal } from 'core'
import { useSelector } from 'react-redux'
import { selectorOrder } from '../../slices/OrderSlice'
import { FlowType } from '../../constants/flowType'
import economicUrlApi from '../../helpers/economicUrlApi'

interface TopUpBalanceProps {
    close?: () => void
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
}

export const TopUpBalance: FC<TopUpBalanceProps> = ({close, competitionId, selectedProjectId}) => {
    const [bundles, setBundles] = useState<any[]>([])
    const { t, i18n } = useTranslation()
    const isMobile = useIsMobile()
    const modal = useModal()
    const order = useSelector(selectorOrder)

    const fetchBundles = async () => {
        const data = await economicUrlApi().getBundles()
        setBundles(API.toLang(data, i18n.language))
    }

    useEffect(() => {
        fetchBundles()
        // return () => {
        //     if (close) {
        //         close()
        //         return
        //     }
        //     modal.show("paymentManager", {
        //         flowType: order.flowType ?? FlowType.BUY_BOOK
        //     })
        // }
        // todo: выяснить, зачем это здесь
    }, [])

    if (!bundles || bundles.length === 0) return <></>

  return (
    <TopUpBalanceWrapperOuter>
        {!isMobile && <TopUpBalanceModalTitle>{t('payment.choose_plan')}</TopUpBalanceModalTitle>}
        <TopUpBalanceWrapper>
            {!isMobile && <TopUpHint>{t('payment.choose_bundle_plan_1')} <br/> {t('payment.choose_bundle_plan_2')}!</TopUpHint>}
            {isMobile && <TopUpBalanceTilte>{t('payment.choose_plan').toLowerCase()}</TopUpBalanceTilte>}

            <BundleList>
                {
                    bundles.map(bundle => (
                        <BundleItem
                            bundle={bundle}
                            key={bundle?.id}
                            close={close}
                            competitionId={competitionId}
                            selectedProjectId={selectedProjectId}
                        />
                    ))
                }
            </BundleList>
        </TopUpBalanceWrapper>
    </TopUpBalanceWrapperOuter>
  )
}

import { FC, useEffect, useState } from 'react'
import { BundleItem } from './BundleItem'
import { BundleList, TopUpBalanceModalTitle, TopUpBalanceTilte, TopUpBalanceWrapper, TopUpBalanceWrapperOuter, TopUpHint } from './styles'
import { API } from '@brg/api'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '@brg/ui'
import { useModal } from 'core'
import { useSelector } from 'react-redux'
import { selectorOrder } from '../../slices/OrderSlice'
import { FlowType } from '../../constants/flowType'
import economicUrlApi from '../../helpers/economicUrlApi'

interface TopUpBalanceProps {
    close?: () => void
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
}

export const TopUpBalance: FC<TopUpBalanceProps> = ({close, competitionId, selectedProjectId}) => {
    const [bundles, setBundles] = useState<any[]>([])
    const { t, i18n } = useTranslation()
    const isMobile = useIsMobile()
    const modal = useModal()
    const order = useSelector(selectorOrder)

    const fetchBundles = async () => {
        const data = await economicUrlApi().getBundles()
        setBundles(API.toLang(data, i18n.language))
    }

    useEffect(() => {
        fetchBundles()
        // return () => {
        //     if (close) {
        //         close()
        //         return
        //     }
        //     modal.show("paymentManager", {
        //         flowType: order.flowType ?? FlowType.BUY_BOOK
        //     })
        // }
        // todo: выяснить, зачем это здесь
    }, [])

    if (!bundles || bundles.length === 0) return <></>

  return (
    <TopUpBalanceWrapperOuter>
        {!isMobile && <TopUpBalanceModalTitle>{t('payment.choose_plan')}</TopUpBalanceModalTitle>}
        <TopUpBalanceWrapper>
            {!isMobile && <TopUpHint>{t('payment.choose_bundle_plan_1')} <br/> {t('payment.choose_bundle_plan_2')}!</TopUpHint>}
            {isMobile && <TopUpBalanceTilte>{t('payment.choose_plan').toLowerCase()}</TopUpBalanceTilte>}

            <BundleList>
                {
                    bundles.map(bundle => (
                        <BundleItem
                            bundle={bundle}
                            key={bundle?.id}
                            close={close}
                            competitionId={competitionId}
                            selectedProjectId={selectedProjectId}
                        />
                    ))
                }
            </BundleList>
        </TopUpBalanceWrapper>
    </TopUpBalanceWrapperOuter>
  )
}

